import React from 'react';
import { Box, TextField, Typography } from '@ublend-npm/aulaui-core';

type ExtensionInfoFormProps = {
  extensionName?: string;
  onExtensionNameChange?: (value: string) => void;
  hasTitle?: boolean;
  isConversion?: boolean;
};

const ExtensionInfoForm = ({
  extensionName = '',
  onExtensionNameChange = () => {},
  hasTitle = true,
  isConversion = false,
}: ExtensionInfoFormProps) => {
  const onExtensionNameFieldChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const {
      target: { value },
    } = e;

    onExtensionNameChange(value);
  };

  return (
    <Box>
      {hasTitle && <Typography component={'span'}>Extension info</Typography>}
      <TextField
        label="Extension name"
        value={extensionName}
        onChange={onExtensionNameFieldChange}
      />
    </Box>
  );
};

export default React.memo(ExtensionInfoForm);
